import React from "react";
import { brand } from "../mock";

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-[#08080a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid md:grid-cols-3 gap-8">
        <div>
          <div className="flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-emerald-400" />
            <span className="font-semibold tracking-[0.22em] text-sm text-white">{brand.name}</span>
          </div>
          <p className="mt-4 text-sm text-neutral-500 max-w-sm">
            A global platform for high-prodigy learning and sales skills. Built for the 2% who close.
          </p>
        </div>

        <div>
          <div className="text-xs tracking-[0.3em] text-neutral-500 uppercase mb-4">Programs</div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li>UDEVA — English & Voice</li>
            <li>Science of Sales</li>
            <li>Pitch Ready</li>
            <li>Corporate Tie-ups</li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.3em] text-neutral-500 uppercase mb-4">Reach</div>
          <ul className="space-y-2 text-sm text-neutral-300">
            <li><a href={`mailto:${brand.email}`} className="hover:text-emerald-400">{brand.email}</a></li>
            <li><a href={`tel:${brand.phone.replace(/\s/g, "")}`} className="hover:text-emerald-400">{brand.phone}</a></li>
            <li className="text-neutral-500">{brand.location}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-neutral-500">
          <div>© {new Date().getFullYear()} Global Tribe. Team AR.</div>
          <div>Where language meets revenue.</div>
        </div>
      </div>
    </footer>
  );
}
